// Where users reach the maintainer. Shown in the footer, user menu, login,
// About, and the legal pages.
export const SUPPORT_EMAIL = "support@mazzella.app";
export const SUPPORT_MAILTO = `mailto:${SUPPORT_EMAIL}?subject=${encodeURIComponent(
  "Caldwell School Lunch support",
)}`;
